<template>
	<div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

		<h1>Consulta Processual - Detalhes do Processo</h1>

		<div class="row" style="font-size: small;">
			<div class="col-2" style="display: flex; gap: 10px;">
				<div style="text-align: left; width: 100%;" class="mb-3" v-if="processo.justica_gratuita">
					<button type="button" class="btn btn-sm btn-danger" style="width: 150px;">
						<label class="btn_azul_lbl">Justiça Gratuita</label>
					</button>
				</div>
				<div style="text-align: left; width: 100%;" class="mb-3" v-if="processo.segredo_justica">
					<button type="button" class="btn btn-sm btn-danger" style="width: 150px;">
						<label class="btn_azul_lbl">Segredo de Justiça</label>
					</button>
				</div>
				<div style="text-align: left; width: 100%;" class="mb-3" v-if="processo.processo_digital">
					<button type="button" class="btn btn-sm btn-danger" style="width: 150px;">
						<label class="btn_azul_lbl">Processo Digitalizado</label>
					</button>
				</div>
			</div>
			<div class="col-10">
				<div style="text-align: right; width: 100%;" class="mb-3">
					<a style="color: black; background-color: lightpink; margin-right: 30px; width: 50px;" class="btn btn-sm" type="button" @click="abrirModalInformativo()" v-if="processo.nivel_sigilo && processo.nivel_sigilo == 1">
						<span class="material-icons">lock_person</span>
					</a>

					<a type="button" class="btn btn-sm btn_cinza" style="width: 50px; margin-right: 50px;" title="Anotações é uma funcionalidade exclusiva deste simulador. Não havendo este botão no sistema oficial do tribunal." @click="abrirModalAnotacoes(processo.id)">
						<label class="btn_cinza_lbl"><span class="material-icons">sticky_note_2</span></label>
					</a>

					<button type="button" class="btn btn-sm btn_azul" style="width: 150px;" @click="DownloadCompleto();">
						<label class="btn_azul_lbl">Download Completo</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" style="width: 130px;" @click="NovaConsulta();">
						<label class="btn_branco_lbl">Nova Consulta</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" @click="Imprimir();">
						<label class="btn_branco_lbl">Imprimir</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" @click="Voltar();">
						<label class="btn_branco_lbl">Voltar</label>
					</button>
				</div>
			</div>
		</div>

		<div class="form-container mb-3" style="background-color: lightpink; font-size: small;">
			<div class="form-title" role="heading" aria-level="3"><!-- Título do form --></div>

			<div class="row">
				<div class="col-3">
					Nº do Processo<br />
					<strong>{{ processo.codigo_processo }}</strong>
				</div>
				<div class="col-3">
					Classe da ação<span class="material-icons" style="font-size: small;">article</span><br />
					<strong>{{ processo.classe_processual?.descricao || 'Não informado' }}</strong>
				</div>
				<div class="col-2">
					Competência<span class="material-icons" style="font-size: small;">article</span><br />
					<strong>{{ processo.rito_area?.descricao || 'Não informado' }}</strong>
				</div>
				<div class="col-2">
					Data de autuação:<br />
					<strong>{{ processo.protocolado_em }}</strong>
				</div>
				<div class="col-2">
					Situação<span class="material-icons" style="font-size: small;">article</span><br />
					<strong>MOVIMENTO</strong>
				</div>
			</div>

			<div class="row">
				<div class="col-4">
					Orgão Julgador:<span class="material-icons" style="font-size: small;">article</span><br />
					<strong>Juízo da 2ª Vara Cível da Comarca de {{ processo.cidade?.descricao || 'Não informada' }}</strong>
				</div>
				<div class="col-4">
					Juíz(a):<span class="material-icons" style="font-size: small;">article</span><br />
					<strong>NOME DO JUÍZ NESTE CAMPO</strong>
				</div>
			</div>

			<div class="row mt-3" v-if="processo.processo_originario">
				<div class="col-12">
					<span class="material-icons" style="font-size: small;">account_tree</span>Processo Originário:
					<strong>{{ processo.processo_originario }}</strong>
				</div>
			</div>

		</div>

		<div class="form-container mb-3" style="font-size: small;">
			<div class="form-title" role="heading" aria-level="3">Lembretes <span class="material-icons-outlined" style="color: orange;" aria-hidden="true">edit</span> <a href="#">Novo</a></div>
		</div>

		<!-- Competência -->
		<div class="form-container mb-3" style="font-size: small;">
			<div class="form-title" @click="toggleCompetencia" style="cursor: pointer;">
				<span class="material-icons" style="vertical-align: middle;">{{ icon_competencia }}</span>
				Competência
			</div>

			<div class="content" v-show="showContentCompetencia" id="competencia-content">

				<!-- Cabeçalho -->
				<div class="row" style="margin-left: 3px; margin-right: 3px;">
					<div class="col-2 borda_partes" style="background-color: lightgray; text-align: center;">
						<strong>Código</strong>
					</div>
					<div class="col-10 borda_partes" style="background-color: lightgray; text-align: center;">
						<strong>Descrição</strong>
					</div>
				</div>

				<!-- Linha com a competência encontrada -->
				<div class="row" style="margin-left: 3px; margin-right: 3px;" v-if="competenciaDoProcesso">
					<div class="col-2 borda_assuntos">
						{{ competenciaDoProcesso.id.toString().padStart(5, '0') }}
					</div>
					<div class="col-10 borda_assuntos">
						{{ competenciaDoProcesso.descricao }}
					</div>
				</div>

				<!-- Caso não tenha -->
				<div class="row" style="margin-left: 3px; margin-right: 3px;" v-else>
					<div class="col-12 borda_assuntos text-center">
						Nenhuma competência vinculada a este processo.
					</div>
				</div>

			</div>
		</div>



		<!-- Assuntos -->
		<div class="form-container mb-3" style="font-size: small;">
			<div class="form-title" @click="toggleAssuntos" style="cursor: pointer;">
				<span class="material-icons" style="vertical-align: middle;">{{ icon_assuntos }}</span>Assuntos
			</div>

			<div class="content" v-show="showContentAssuntos" id="assuntos-content">

				<div class="row" style="margin-left: 3px; margin-right: 3px;">
					<div class="col-2 borda_partes" style="background-color: lightgray; text-align: center;">
						<strong>Código</strong>
					</div>
					<div class="col-8 borda_partes" style="background-color: lightgray; text-align: center;">
						<strong>Descrição</strong>
					</div>
					<div class="col-2 borda_partes" style="background-color: lightgray; text-align: center;">
						<strong>Principal</strong>
					</div>
				</div>
				<div class="row" style="margin-left: 3px; margin-right: 3px;" v-for="assunto in processo.assuntos">
					<div class="col-2 borda_assuntos">
						{{ assunto.id.toString().padStart(5, '0') }}
					</div>
					<div class="col-8 borda_assuntos">
						{{ assunto.descricao }}
					</div>
					<div class="col-2 borda_assuntos text-center">
						{{ assunto.pivot.assunto_principal ? "Sim" : "Não" }}
					</div>
				</div>

			</div>

		</div>


		<!-- Partes e Representantes -->
		<div class="form-container mb-3" style="font-size: small;">
			<div class="form-title" role="heading" aria-level="3">Partes e Representantes&nbsp;<span class="material-icons" style="font-size: small;" aria-hidden="true">article</span></div>

			<div class="container mt-3">
				<div class="row">
					<div class="col-6 borda_partes" style="background-color: lightgray; text-align: center;">
						<strong>AUTOR</strong>
					</div>
					<div class="col-6 borda_partes" style="background-color: lightgray; text-align: center;">
						<strong>RÉU</strong>
					</div>
				</div>
				<div class="row">
					<div class="col-6 borda_partes">
						<ul>
							<div v-for="parte in processo.partes">
								<li v-if="parte.pivot.polo_ativo === 1" style="list-style-type: none;">
									<span class="parte_ativa">{{ parte.nome }}</span> - {{
										parte.cpf_cnpj
											? (parte.cpf_cnpj.length > 14
												? '(' + parte.cpf_cnpj + ') Pessoa Jurídica'
												: '(' + parte.cpf_cnpj + ') Pessoa Física')
											: '(CPF/CNPJ não informado)'
									}}
								</li>
							</div>

							<br />

							<div v-for="advogado in processo.advogados">
								<li v-if="advogado.pivot.autor === 1 || advogado.pivot.colaborador_autor === 1" style="list-style-type: none;">
									<span>{{ advogado.name }}</span> - {{ advogado.oab }}
								</li>
							</div>

						</ul>

					</div>
					<div class="col-6 borda_partes">
						<ul>
							<div v-for="parte in processo.partes">
								<li v-if="parte.pivot.polo_passivo === 1" style="list-style-type: none;">
									<span class="parte_passiva">{{ parte.nome }}</span> - {{
										parte.cpf_cnpj
											? (parte.cpf_cnpj.length > 14
												? '(' + parte.cpf_cnpj + ') Pessoa Jurídica'
												: '(' + parte.cpf_cnpj + ') Pessoa Física')
											: '(CPF/CNPJ não informado)'
									}}
								</li>
							</div>

							<br />

							<div v-for="advogado in processo.advogados">
								<li v-if="advogado.pivot.defensor_reu === 1" style="list-style-type: none;">
									<span>{{ advogado.name }}</span> - {{ advogado.oab }}
								</li>
							</div>


						</ul>
					</div>
					<div class="col-12 borda_partes" style="background-color: lightgray; text-align: center;">
						<strong>PERITO</strong>
					</div>
					<div class="col-12 borda_partes mb-5" style="text-align: center;">
						<span class="perito">NOME PERITO</span> (000.000.000-00) - Pessoa Física
					</div>
				</div>

			</div>
		</div>

		<!-- Informações Adicionais -->
		<div class="form-container mb-3" style="font-size: small;">
			<!-- Botão para expandir/recolher com método e ícone dinâmico -->
			<div class="form-title" @click="toggle" style="cursor: pointer;">
				<span class="material-icons" style="vertical-align: middle;">{{ icon }}</span>
				Informações Adicionais <span style="color: lightgreen;">(Prevenção: NÃO há prevento)</span>
			</div>

			<!-- Conteúdo controlado por v-show para alternância dinâmica -->
			<div class="content" v-show="showContent" id="info-adicionais-content">
				<div class="row">
					<div class="col-2" style="text-align: right;">Anexos Eletrônicos</div>
					<div class="col-2" style="text-align: left;" v-if="processo.peticoes?.[0]?.documentos">
						<span style="font-weight: bold; color: blue;" v-if="processo.peticoes[0].documentos.length == 0">Não há anexos</span>
						<span style="font-weight: bold; color: green;" v-else>{{ processo.peticoes[0].documentos.length }} anexos</span>
					</div>
					<div class="col-2" style="text-align: right;">Conciliações Virtuais:</div>
					<div class="col-2" style="text-align: left;"><strong>{{ TemInformacao(7) ? "Sim" : "Não" }}</strong></div>
					<div class="col-2" style="text-align: right;">Usuários com Vista ao Processo:</div>
					<div class="col-2" style="text-align: left;"><span class="material-icons" style="font-size: small;">article</span></div>
				</div>

				<div class="row">
					<div class="col-2" style="text-align: right;">Antecipação de Tutela:</div>
					<div class="col-2" style="text-align: left;"><strong>{{ processo.antecipacao_tutela ? 'Sim' : 'Não' }}</strong></div>
					<div class="col-2" style="text-align: right;">Autor manifesta desinteresse na conciliação:</div>
					<div class="col-2" style="text-align: left;"><strong>{{ processo.tem_interesse_conciliar ? 'Sim' : 'Não' }}</strong></div>
					<div class="col-2" style="text-align: right;">Chave Processo:</div>
					<div class="col-2" style="text-align: left;" v-if="!mostrar_chave_processo">
						<a @click="MostrarChaveProcesso" style="cursor: pointer;"><span class="material-icons" style="font-size: x-large">key</span></a>
					</div>
					<div class="col-2" style="text-align: left;" v-else>
						<a @click="MostrarChaveProcesso" style="cursor: pointer;"><span>{{ processo.chave_processo }}</span></a>
					</div>
				</div>

				<div class="row">
					<div class="col-2" style="text-align: right;">Criança e Adolescente:</div>
					<div class="col-2" style="text-align: left;"><strong>{{ TemInformacao(5) ? "Sim" : "Não" }}</strong></div>
					<div class="col-2" style="text-align: right;">Doença Grave:</div>
					<div class="col-2" style="text-align: left;"><strong>{{ TemInformacao(1) ? "Sim" : "Não" }}</strong></div>
					<div class="col-2" style="text-align: right;">Grande Devedor:</div>
					<div class="col-2" style="text-align: left;"><strong>Não</strong></div>
				</div>

				<div class="row">
					<div class="col-2" style="text-align: right;">Idoso:</div>
					<div class="col-2" style="text-align: left;"><strong>{{ TemInformacao(3) ? "Sim" : "Não" }}</strong></div>
					<div class="col-2" style="text-align: right;">Justiça Gratuita:</div>
					<div class="col-2" style="text-align: left;"><strong>{{ processo.justica_gratuita ? 'Deferida' : 'Indeferida' }}</strong></div>
					<div class="col-2" style="text-align: right;">Nível de Sigilo do Processo:</div>
					<div class="col-2" style="text-align: left;"><strong>{{ processo.nivel_sigilo ? 'Com Sigilo (Nível 1)' : 'Sem Sigilo (Nível 0)' }}</strong></div>
				</div>

				<div class="row">
					<div class="col-2" style="text-align: right;">Penhora no rosto dos autos:</div>
					<div class="col-2" style="text-align: left;"><strong>Não</strong></div>
					<div class="col-2" style="text-align: right;">Penhora/apreensão de bens:</div>
					<div class="col-2" style="text-align: left;"><strong>Não</strong></div>
					<div class="col-2" style="text-align: right;">Pessoa com deficiência:</div>
					<div class="col-2" style="text-align: left;"><strong>{{ TemInformacao(4) ? "Sim" : "Não" }}</strong></div>
				</div>

				<div class="row">
					<div class="col-2" style="text-align: right;">Petição Urgente:</div>
					<div class="col-2" style="text-align: left;"><strong>Não</strong></div>
					<div class="col-2" style="text-align: right;">Possui bem Apreendido:</div>
					<div class="col-2" style="text-align: left;"><strong>Não</strong></div>
					<div class="col-2" style="text-align: right;">Precatórios/RPV:</div>
					<div class="col-2" style="text-align: left;"><strong>Não</strong></div>
				</div>

				<div class="row">
					<div class="col-2" style="text-align: right;">Prevenção:</div>
					<div class="col-2" style="text-align: left;"><strong><span style="color: green;">Não há prevento</span></strong></div>
					<div class="col-2" style="text-align: right;">Processo Digitalizado:</div>
					<div class="col-2" style="text-align: left;"><strong>{{ processo.processo_digital ? 'Sim' : 'Não' }}</strong></div>
					<div class="col-2" style="text-align: right;">Reconvenção:</div>
					<div class="col-2" style="text-align: left;"><strong>Não</strong></div>
				</div>

				<div class="row">
					<div class="col-2" style="text-align: right;">Réu Preso:</div>
					<div class="col-2" style="text-align: left;"><strong>Não</strong></div>
					<div class="col-2" style="text-align: right;">Valor da Causa:</div>
					<div class="col-2" style="text-align: left;"><strong>{{ processo.valor_causa }}</strong></div>
					<div class="col-2" style="text-align: right;">Vista Ministério Público:</div>
					<div class="col-2" style="text-align: left;"><strong>Não</strong></div>
				</div>

			</div>
		</div>


		<!-- Ações -->
		<div class="form-container mb-3" style="font-size: small;" v-if="user != null">
			<div class="form-title" role="heading" aria-level="3">Ações</div>

			<div class="row">
				<div class="col-12 text-center">
					<button type="button" class="btn btn-sm btn_branco" style="margin: 1px; border: solid 1px #C3C3C3;">
						<label class="btn_branco_lbl">Agravo</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" style="width: 130px; margin: 1px; border: solid 1px #C3C3C3;">
						<label class="btn_branco_lbl">Alvará Eletrônico</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" style="margin: 1px; border: solid 1px #C3C3C3;">
						<label class="btn_branco_lbl">Árvore</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" style="margin: 1px; border: solid 1px #C3C3C3;">
						<label class="btn_branco_lbl">Audiência</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" style="width: 150px; margin: 1px; border: solid 1px #C3C3C3;">
						<label class="btn_branco_lbl">Certidão Narratória</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" style="margin: 1px; border: solid 1px #C3C3C3;">
						<label class="btn_branco_lbl">Custas</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" style="width: 150px; margin: 1px; border: solid 1px #C3C3C3;">
						<label class="btn_branco_lbl">Depósitos Judiciais</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" style="width: 130px; margin: 1px; border: solid 1px #C3C3C3;">
						<label class="btn_branco_lbl">Incluir Intimados</label>
					</button>

					<span title="Apenas advogados do processo ou professores podem movimentar/peticionar.">
						<button type="button" class="btn btn-sm btn_branco" style="width: 155px; margin: 1px; border: solid 1px #C3C3C3;" @click="Movimentar('movimentar')" :disabled="!podeMovimentar()">
							<label class="btn_branco_lbl">Movimentar/Peticionar</label>
						</button>
					</span>

					<button type="button" class="btn btn-sm btn_branco" style="width: 130px; margin: 1px; border: solid 1px #C3C3C3;">
						<label class="btn_branco_lbl">Perícia</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" style="width: 230px; margin: 1px; border: solid 1px #C3C3C3;">
						<label class="btn_branco_lbl">Pessoa enquadrada na LEI 14.289</label>
					</button>

					<span title="Apenas advogados do processo ou professores podem substabelecer.">
						<button type="button" class="btn btn-sm btn_branco" style="width: 130px; margin: 1px; border: solid 1px #C3C3C3;" @click="Substabelecer();" :disabled="!podeMovimentar()">
							<label class="btn_branco_lbl">Substabelecimento</label>
						</button>
					</span>
				</div>
			</div>
		</div>




		<div class="row" style="font-size: small;">
			<div class="col-8 mb-3">
			</div>
			<div class="col-4 mb-3 d-flex justify-content-end">

				<div class="input-group">
					<button type="button" class="btn btn-sm btn_branco">
						<label class="btn_branco_lbl">
							<span class="material-icons" style="font-size: small;">filter_alt</span>
							Filtros
							<span class="material-icons" style="font-size: small;">expand_more</span>
						</label>
					</button>

					<input type="text" placeholder="Pesquisar nos Eventos">
					<span class="input-group-text">
						<i class="material-icons" style="font-size: small;">search</i> <!-- Ícone de lupa do Bootstrap Icons -->
					</span>
				</div>
			</div>
		</div>

		<!-- Eventos -->
		<div class="form-container mb-3" style="font-size: small;">
			<div class="form-title" role="heading" aria-level="3">Eventos</div>

			<table class="table">
				<thead>
					<tr style="background-color: lightslategray;">
						<th style="text-align: center;" scope="col">Evento</th>
						<th style="text-align: center;" scope="col">Data/Hora</th>
						<th style="text-align: center;" scope="col">Descrição</th>
						<th style="text-align: center;" scope="col">Usuário</th>
						<th style="text-align: center;" scope="col">Documentos</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(peticao, index) in reversedPeticoes" :key="peticao.id">
						<td style="text-align: center;">{{ reversedPeticoes.length - index }}</td>
						<td style="text-align: center;">{{ formatDate(peticao.created_at) }}</td>
						<td style="text-align: left; position: relative;" :style="peticao.prazo && peticao.concluido ? { backgroundColor: '#d4edda' } : {}">
							<!-- Ícone de concluído no canto superior direito (se tiver prazo e estiver concluído) -->
							<i v-if="peticao.prazo && peticao.concluido" class="material-icons" style="position: absolute; top: 2px; right: 4px; font-size: 16px; color: #155724;">
								check_circle
							</i>

							<!-- Se tiver prazo, não estiver concluído e prazo já passou: "Decorrido prazo" -->
							<div v-if="peticao.prazo && !peticao.concluido && new Date(peticao.prazo) < new Date()">
								<small style="color: #b71c1c; font-weight: bold;">
									Decorrido prazo
								</small>
							</div>

							<!-- Referência ao evento (mantido, mas agora pode vir após "Decorrido prazo") -->
							<div v-if="peticao.referente_ao_evento">
								<small>
									Refer. ao Evento {{ numeroEventoPorId(peticao.referente_ao_evento) }}
								</small>
							</div>

							<!-- Tipo e descrição da petição -->
							<span style="background-color: green; color: white;">
								{{ peticao?.tipo?.descricao == null ? '' : peticao.tipo.descricao }}
							</span>
							{{ (peticao?.descricao == null) ? "" : " - " + peticao.descricao }}
							<br />

							<!-- Linha do usuário/tipo advogado (como já estava) -->
							<span>{{ peticao.usuario_criador?.id ? "" : "" }}</span>
							<span :class="getClass(peticao.tipo_advogado)">
								{{ peticao.tipo_advogado }}
							</span>
							- {{ peticao.usuario_criador?.name || 'Usuário não informado' }}

							<!-- Se existir prazo, mostra "Prazo final: ..." ao final -->
							<div v-if="peticao.prazo">
								<br />
								<small>
									Prazo final: {{ formatDateSemHora(peticao.prazo) }}
								</small>
							</div>
						</td>
						<td style="text-align: center;">{{ peticao.usuario_criador?.name || 'Usuário não informado' }}</td>
						<td style="text-align: left;">
							<ul>
								<li v-for="documento in peticao.documentos" :key="documento.id" style="list-style-type: none;">
									<!-- Se o usuário PODE ver este documento -->
									<template v-if="podeVerDocumento(documento)">
										<a href="#" @click.prevent="openPdfModal(documento.path)">
											<i class="material-icons" style="color: black;">article</i>
											{{ documento.descricao }}
										</a>
									</template>

									<!-- Se o usuário NÃO pode ver este documento -->
									<template v-else>
										<i class="material-icons" style="color: gray;">lock</i>
										<span style="font-size: 12px; color: #666;">
											Documento protegido por sigilo.
										</span>
									</template>
								</li>
							</ul>

							<!-- Botões só aparecem se houver ao menos UM documento visível para o usuário -->
							<div v-if="peticao.documentos.some(d => podeVerDocumento(d))" style="text-align: right;">
								<i class="material-icons" style="color: black; cursor: pointer;" @click="downloadAllDocuments(peticao.documentos.filter(d => podeVerDocumento(d)))">
									download
								</i>

								<i class="material-icons" style="color: black; cursor: pointer;" @click="openAllDocuments(peticao.documentos.filter(d => podeVerDocumento(d)))">
									content_copy
								</i>
							</div>

							<!-- Se NÃO houver nenhum documento que ele possa ver -->
							<div v-else>
								<em style="font-size: 12px; color: #666;">
									Nenhum documento disponível para visualização com o seu perfil de acesso.
								</em>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

	</div>

	<!-- Modal -->
	<div class="modal fade" id="pdfModal" tabindex="-1" role="dialog" aria-labelledby="pdfModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-xl modal-dialog-centered" role="document" style="max-width: 80vw;">
			<div class="modal-content" style="background-color: lightgray;">
				<div class="modal-header">
					<h5 class="modal-title" id="pdfModalLabel"><!-- Visualização do PDF --></h5>
					<button type="button" class="close" @click="closePdfModal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<iframe id="pdfViewer" :src="pdfSrc" style="width: 100%; height: 80vh;" frameborder="0"></iframe>
				</div>
			</div>
		</div>
	</div>

	<ProcessosAnotacoesComponent :processo="processo" :mostrarModalAnotacoes="mostrarModalAnotacoes" :user="user" @fecharAnotacoes="mostrarModalAnotacoes = false" />

	<!-- Modal (só aparece se mostrarModalInformativo = true) -->
	<div v-if="mostrarModalInformativo" class="modal-overlay" @click.self="fecharModalInformativo" role="dialog" aria-modal="true" aria-labelledby="modalInfoTitle">
		<div class="modal-content">
			<div class="modal-header">
				<h5 id="modalInfoTitle">Processo sigiloso</h5>
				<button class="close-btn" @click="fecharModalInformativo">x</button>
			</div>
			<div class="modal-body">
				<p style="text-align: justify;">
					Quando criado, este processo foi definido como sigiloso. Assim, neste simulador, somente os administradores (professores) e advogados envolvidos neste processo terão acesso aos documentos.
				</p>
			</div>
			<div class="modal-footer">
				<button class="btn-fechar" @click="fecharModalInformativo">Fechar</button>
			</div>
		</div>
	</div>

</template>

<script>
	import ProcessosAnotacoesComponent from './ProcessosAnotacoesComponent.vue'
	export default {
		data() {
			return {
				BASE_URL: window.Laravel.baseUrl,
				showContent: false,
				showContentAssuntos: false,
				showContentCompetencia: false,

				isModalVisible: false,
				pdfSrc: '',

				mostrar_chave_processo: false,
				mostrarModalAnotacoes: false,
				mostrarModalInformativo: false,

				competencias: [],
			};
		},
		props: {
			user: {
				type: Object,
			},
			processo: {
				type: Object,
			},
		},
		methods: {
			formatDateSemHora(value) {
				if (value) {
					const date = new Date(value);
					const day = date.getDate().toString().padStart(2, '0');
					const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Janeiro é 0!
					const year = date.getFullYear();
					//const hours = date.getHours().toString().padStart(2, '0');
					//const minutes = date.getMinutes().toString().padStart(2, '0');
					//const seconds = date.getSeconds().toString().padStart(2, '0');
					return `${day}/${month}/${year}`;
				}
				return '';
			},
			openAnotacoesModal(processoId) {
				// chama método público do wrapper para abrir e setar o ID
				this.$refs.anotacoesModal.open(processoId)
			},
			abrirModalAnotacoes(processoId) {

				this.mostrarModalAnotacoes = true;
			},

			abrirModalInformativo() {
				this.mostrarModalInformativo = true;
			},

			fecharModalInformativo() {
				this.mostrarModalInformativo = false;
			},

			MostrarChaveProcesso() {
				this.mostrar_chave_processo = !this.mostrar_chave_processo;
			},
			openPdfModal(path) {
				// Defina o src do iframe para o caminho do PDF
				this.pdfSrc = this.link_arquivo(path);
				// Mostrar o modal com Bootstrap jQuery
				$('#pdfModal').modal('show');
			},
			closePdfModal() {
				// Esconder o modal com Bootstrap jQuery
				$('#pdfModal').modal('hide');
			},

			Imprimir() {
				window.print();
			},
			Voltar() {
				window.history.back();
			},
			NovaConsulta() {
				window.location.href = this.BASE_URL + "processos/consultar";
			},
			DownloadCompleto() {
				window.location.href = this.BASE_URL + "processos/opcoesdownload/" + this.processo.id;
			},
			toggle() {
				this.showContent = !this.showContent;
			},
			toggleAssuntos() {
				this.showContentAssuntos = !this.showContentAssuntos;
			},
			toggleCompetencia() {
				this.showContentCompetencia = !this.showContentCompetencia;
			},
			TemInformacao(info_id) {
				// Retorna true se algum item no array satisfaz a condição
				return this.processo.informacoes_adicionais.some(info => info.id === info_id);
			},
			link_arquivo(path) {
				if (!path) return '';

				// Remove barras duplicadas internas só no final/início
				const base = this.BASE_URL.endsWith('/') ? this.BASE_URL.slice(0, -1) : this.BASE_URL;
				const cleanPath = path.startsWith('/') ? path.slice(1) : path;

				// Junta com apenas uma barra
				return `${base}/${cleanPath}`;
			},
			downloadAllDocuments(documentos) {
				documentos.forEach(documento => {
					const link = document.createElement('a');
					link.href = this.link_arquivo(documento.path);
					link.download = documento.descricao || 'download';  // Usando a descrição do documento como nome do arquivo, se disponível
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
			},
			openAllDocuments(documentos) {
				documentos.forEach(documento => {
					const link = document.createElement('a');
					link.href = this.link_arquivo(documento.path);
					link.target = '_blank';  // Isso faz com que o link abra em uma nova aba
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
			},
			Movimentar(acao) {
				window.location.href = this.BASE_URL + "processos/movimentacao_processual_detalhes/" + this.processo.id;
			},
			Substabelecer() {
				window.location.href = this.BASE_URL + "processos/substabelecer/" + this.processo.id;
			},
			formatDate(value) {
				if (value) {
					const date = new Date(value);
					const day = date.getDate().toString().padStart(2, '0');
					const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Janeiro é 0!
					const year = date.getFullYear();
					const hours = date.getHours().toString().padStart(2, '0');
					const minutes = date.getMinutes().toString().padStart(2, '0');
					const seconds = date.getSeconds().toString().padStart(2, '0');
					return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
				}
				return '';
			},
			getClass(tipoAdvogado) {
				return {
					autor: tipoAdvogado === 'AUTOR',
					reu: tipoAdvogado === 'RÉU'
				};
			},
			CarregarCompetencias() {
				axios.get(this.BASE_URL + 'buscar/competencias')
					.then(response => {
						this.competencias = response.data;
					})
					.catch(error => {
						console.error('Erro ao buscar informações os assuntos:', error);
					});
			},
			podeMovimentar() {
				return this.isAdmin() || this.ehAdvogadoDoProcesso();
			},
			isAdmin() {
				return this.user && this.user.is_admin;
			},

			ehAdvogadoDoProcesso() {
				return this.user
					&& Array.isArray(this.processo.advogados)
					&& this.processo.advogados.some(adv =>
						String(adv.id) === String(this.user.id)
					);
			},

			podeVerDocumento(documento) {
				const sigiloProcesso = this.processo.nivel_sigilo == "1";
				const isConfidential = documento.confidencial == "1" || documento.confidencial == 1;

				const temPermissao = this.isAdmin() || this.ehAdvogadoDoProcesso();


				// 1) Processo sigiloso → só admin ou advogado vê qualquer documento
				if (sigiloProcesso) {
					return temPermissao;
				}


				if (!isConfidential) {
					return true;
				}

				return temPermissao;
			},
			numeroEventoPorId(peticaoId) {
				if (!peticaoId) return null;

				const idx = this.reversedPeticoes.findIndex(p => p.id == peticaoId);

				if (idx === -1) {
					return null; // caso não ache (segurança)
				}

				// mesma lógica que você usa na coluna Evento: length - index
				return this.reversedPeticoes.length - idx;
			}
		},
		computed: {
			icon() {
				return this.showContent ? 'remove' : 'add';
			},
			icon_assuntos() {
				return this.showContentAssuntos ? 'remove' : 'add';
			},
			icon_competencia() {
				return this.showContentCompetencia ? 'remove' : 'add';
			},
			reversedPeticoes() {
				return [...this.processo.peticoes].reverse();
			},
			competenciaDoProcesso() {
				if (!this.processo || !this.processo.competencia_id) {
					return null;
				}

				return this.competencias.find(
					c => c.id === this.processo.competencia_id
				) || null;
			},
		},
		mounted() {


			this.CarregarCompetencias();
		},

	};
</script>

<style scoped>
	h1 {
		font-size: 26px;
	}

	.form-container {
		border: 1px solid gray;
		/* Borda fina cinza */
		padding: 10px;
		position: relative;
		/* Posição relativa para o posicionamento do título */
		margin-top: 5px;
		/* Espaçamento superior para visualização do título */
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
		background-color: #FFFFFF;
	}

	.form-title {
		position: absolute;
		/* Posicionamento absoluto do título */
		top: -15px;
		/* Posiciona o título acima da borda */
		left: 10px;
		/* Espaçamento da esquerda para o título */
		background: white;
		/* Fundo branco para o título */
		padding: 0 1px;
		/* Espaçamento interno do título */
		font-weight: bold;
		;
	}

	.btn_azul {
		margin-right: 3px;
		width: 90px;
		cursor: pointer;
		background-color: #007BFF;
	}

	.btn_branco {
		margin-right: 2px;
		width: 90px;
		cursor: pointer;
		background-color: white;
	}

	.btn_branco:disabled {
		border: #FFFFFF 0px solid;
	}

	.btn_cinza {
		margin-right: 2px;
		width: 90px;
		cursor: pointer;
		background-color: rgb(170, 170, 170);
	}

	.btn_azul_lbl {
		color: white;
		vertical-align: middle;
		cursor: pointer;
	}

	.btn_cinza_lbl {
		color: #4c4f52;
		vertical-align: middle;
		cursor: pointer;
	}

	.btn_branco_lbl {
		color: #007BFF;
		vertical-align: middle;
		cursor: pointer;
	}

	.borda_partes {
		border: 1px solid darkgray;
	}

	.borda_assuntos {
		border: 1px solid darkgray;
	}

	.parte_ativa {
		background-color: darkblue;
		color: white;
		padding: 3px;
	}

	.parte_ativa:hover {
		background-color: darkblue;
		color: white;
		padding: 3px;
		text-decoration: underline;
		cursor: pointer;
	}

	.parte_passiva {
		background-color: brown;
		color: white;
		padding: 3px;
	}

	.parte_passiva:hover {
		background-color: brown;
		color: white;
		padding: 3px;
		text-decoration: underline;
		cursor: pointer;
	}

	.perito {
		background-color: gray;
		color: white;
		padding: 3px;
	}

	.perito:hover {
		background-color: gray;
		color: white;
		padding: 3px;
		text-decoration: underline;
		cursor: pointer;
	}

	.autor {
		background-color: blue;
		color: white;
	}

	.reu {
		background-color: red;
		color: white;
	}


	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.45);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
	}

	.modal-overlay .modal-content {
		background: white;
		width: 380px;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
	}

	.modal-overlay .modal-header {
		padding: 10px 15px;
		background: #f8f8f8;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.close-btn {
		background: none;
		border: none;
		font-size: 22px;
		cursor: pointer;
	}

	.modal-overlay .modal-body {
		padding: 15px;
		font-size: 15px;
		color: #333;
	}

	.modal-overlay .modal-footer {
		padding: 10px 15px;
		background: #f8f8f8;
		text-align: right;
	}

	.btn-fechar {
		background: #555;
		color: white;
		border: none;
		padding: 6px 12px;
		border-radius: 6px;
		cursor: pointer;
	}


</style>
